import { Flex, HStack, Image, Text, useBreakpointValue } from '@chakra-ui/react';

import CompletionStatusTag from '@/client/components/learners/dashboard/components/lists/LearnerDashboardCompletionStatusTag';
import type { DefaultTFuncReturn } from 'i18next';

interface LearnerDashboardContentListItemProps {
  title: string | undefined;
  typeLabel: string;
  renderBottomBorder: boolean;
  imageUrl: string | undefined;
  statusData:
    | {
        statusText: DefaultTFuncReturn | undefined;
        status: 'completed' | 'completedOverdue' | 'overdue' | 'notStarted' | undefined;
      }
    | undefined;
  onClick: () => void;
}

export default function LearnerDashboardContentListItem({
  title,
  typeLabel,
  renderBottomBorder,
  imageUrl,
  statusData,
  onClick,
}: LearnerDashboardContentListItemProps) {
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Flex
      paddingY={6}
      paddingX={2}
      borderRadius="4px"
      borderBottom="1px solid"
      alignItems={isMobile ? 'flex-start' : 'center'}
      borderColor={renderBottomBorder ? 'neutral.100' : 'transparent'}
      direction={{ base: 'column', md: 'row' }}
      _hover={{
        cursor: 'pointer',
        backgroundColor: 'neutral.100',
      }}
      onClick={onClick}
    >
      <HStack spacing={4} minWidth="60%" maxWidth="50%">
        <Image
          minWidth="65px"
          minHeight="35px"
          width="65px"
          height="35px"
          borderRadius="4px"
          backgroundColor="brand.primary"
          src={imageUrl}
        />

        <Text fontSize="14px" fontWeight={500} color="baseBlack" _hover={{ cursor: 'pointer' }}>
          {title}
        </Text>
      </HStack>

      <Flex flex={1} justifyContent="space-between" paddingLeft={isMobile ? 20 : 0}>
        {!isMobile && (
          <Text fontSize="10px" fontWeight={600} textTransform="uppercase" color="neutral.800">
            {typeLabel}
          </Text>
        )}

        <CompletionStatusTag statusData={statusData} />
      </Flex>
    </Flex>
  );
}
